export const COMMON_TIMEZONES = [
  "America/Bogota", "America/Mexico_City", "America/Lima", "America/Santiago",
  "America/Argentina/Buenos_Aires", "America/Sao_Paulo", "America/New_York",
  "America/Los_Angeles", "America/Caracas", "America/La_Paz", "America/Guatemala",
  "America/Panama", "America/Montevideo", "America/Costa_Rica",
  "Europe/Madrid", "Europe/London", "Europe/Paris", "Atlantic/Canary", "UTC",
];

export function detectTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Bogota";
  } catch {
    return "America/Bogota";
  }
}

export function tzList() {
  const d = detectTimezone();
  return COMMON_TIMEZONES.includes(d) ? COMMON_TIMEZONES : [d, ...COMMON_TIMEZONES];
}
